/**
 * WHAT: Module Error Handler
 * WHY: Handle JavaScript module loading errors gracefully
 * HOW: Listen for module errors and display user-friendly message
 * IMPORTANCE: User experience - prevents blank page on module errors
 */

// WHAT: Listen for global JavaScript errors
// WHY: Catch module loading failures and other critical errors
// HOW: Add event listener to window error event
window.addEventListener('error', function(e) {
    // WHAT: Check if error is related to module loading
    // WHY: Module errors indicate browser compatibility or build issues
    // HOW: Check error message for 'module' keyword
    if (e.message.includes('module')) {
        // WHAT: Log error for debugging
        // WHY: Developers need to know about module loading failures
        // HOW: Use console.error (safe in production for critical errors)
        console.error('Module loading error:', e);
        
        // WHAT: Display user-friendly error message
        // WHY: Users shouldn't see blank page or cryptic errors
        // HOW: Replace page content with error message
        // SECURITY: Using innerHTML here is safe because content is static, not user-controlled
        document.body.innerHTML = `
            <div class="error-message" style="padding: 20px; text-align: center;">
                <h1>Error Loading Page</h1>
                <p>Please ensure your browser supports JavaScript modules.</p>
            </div>
        `;
    }
});





